function n(e, a) {
  const t = new Date(e);
  return t.setDate(t.getDate() + a), t;
}
export {
  n as addDays
};
//# sourceMappingURL=helpers.js.map
